module.exports = __webpack_public_path__ + "img/image_big_logo.ba829e1a.png";